import graphql from "babel-plugin-relay/macro";
import { useCallback } from "react";

import { useMutationWithError } from "@/utils/hooks/useMutationWithError";
import { useFlags } from "@/utils/launchDarkly/useFlags";

import {
  BookingType,
  useUpdateRoundPunchPassesMutation,
} from "./__generated__/useUpdateRoundPunchPassesMutation.graphql";

export const useUpdateRoundPunchPasses = (
  bookingType: BookingType,
  membershipTypeId: string
) => {
  const { patronLoyalty } = useFlags();
  const [commitMutation, isUpdating] =
    useMutationWithError<useUpdateRoundPunchPassesMutation>(
      useUpdateRoundPunchPassesMutationString
    );

  const updateRoundPunchPasses = useCallback(
    (
      roundId: string,
      playerPunchPassId: string | null,
      transportationPunchPassId: string | null,
      onCompleted: () => void
    ) => {
      commitMutation({
        variables: {
          input: {
            roundId,
            playerPunchPassId,
            transportationPunchPassId,
          },
          bookingType,
          membershipTypeId,
          patronLoyalty: !!patronLoyalty,
        },
        onCompleted: () => {
          onCompleted();
        },
      });
    },
    [commitMutation, bookingType, membershipTypeId, patronLoyalty]
  );

  return [updateRoundPunchPasses, isUpdating] as const;
};

const useUpdateRoundPunchPassesMutationString = graphql`
  mutation useUpdateRoundPunchPassesMutation(
    $input: UpdateRoundPunchPassesInput!
    $bookingType: BookingType!
    $membershipTypeId: ID!
    $patronLoyalty: Boolean!
  ) {
    responsePayload: updateRoundPunchPasses(input: $input) {
      round {
        id
        booking {
          ...BookingSummary_booking @arguments(patronLoyalty: $patronLoyalty)
        }
      }
      errors {
        field
        code
        message
      }
      success
    }
  }
`;
